// Menú de competiciones del CMS -> lo que consumen los loaders y las vistas

export const getCompetitionsToMap = (menu) => {
    const competitions = menu.reduce((accumulator, currentObject) => {
        currentObject.extras.forEach(comp => {
            accumulator.ids[comp.id] = true;
            accumulator.result.push(comp);
        });
        return accumulator;
    }, { result: [], ids: {} }).result.map((item) => {
        return {
            ...item,
            oldCompetitionSlug: item.url,
            liga: item.liga
        };
    });

    return competitions;
};


export const getUniqueCompetitions = (menuCompetitions) => {
    if (menuCompetitions.length > 0) {
        return [...new Set(menuCompetitions.flatMap(item => item.extras || [])
            .map(extra => extra.id))].map(id => menuCompetitions.flatMap(item => item.extras || []).find(extra => extra.id === id));
    }
    return [];
}
